import { BaseUser } from '@core/models/user';
import axios from 'axios';

async function getCropwiseUser(token: string) {
  const url = `${import.meta.env.VITE_APP_CROPWISE_BASE}/v2`;

  return axios.get<BaseUser>(`${url}/accounts/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export { getCropwiseUser };
